import { useContext, useMemo } from 'react';
import {
  FIELDIDENTIFIER,
  findAllValuesToReplace,
  replaceAllBuzzwordsWithValues,
  SYSTEMIDENTIFIER,
} from '../../../textAreaUtils';
import FormStateContext from '../../../../../pages/formState';

/**
 * Hook to replace buzzwords and system identifiers.
 */
export function useBuzzwordReplacement(content?: string) {
  const { form } = useContext(FormStateContext);

  const buzzwords = useMemo(
    () => (content ? findAllValuesToReplace(content, FIELDIDENTIFIER) : []),
    [content]
  );

  const systemBuzzwords = useMemo(
    () => (content ? findAllValuesToReplace(content, SYSTEMIDENTIFIER) : []),
    [content]
  );

  const relevantValues = useMemo(() => {
    if (!form) return {};
    const fieldNames = buzzwords.map((b) => b.replace(FIELDIDENTIFIER, ''));
    return fieldNames.reduce<Record<string, any>>((acc, name) => {
      if (form[name] !== undefined) acc[name] = form[name];
      return acc;
    }, {});
  }, [form, buzzwords]);

  return useMemo(() => {
    if (!content) return '';
    return replaceAllBuzzwordsWithValues(
      relevantValues,
      buzzwords,
      systemBuzzwords,
      content
    );
  }, [relevantValues, buzzwords, systemBuzzwords, content]);
}
